import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { ReactComponent as LogoIcon } from "../Icons/logo.svg";
import { ReactComponent as LocationIcon } from "../Icons/location.svg";
import { ReactComponent as PhoneIcon } from "../Icons/phone.svg";
import { useMediaQuery } from "@mui/material";
import ArticleIcon from "@mui/icons-material/Article";
import SecurityIcon from "@mui/icons-material/Security";
import { useNavigate } from "react-router-dom";
import PolicyIcon from "@mui/icons-material/Policy";
import GavelIcon from "@mui/icons-material/Gavel";
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import InfoIcon from '@mui/icons-material/Info';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import { useTranslation } from "react-i18next";

export default function () {
  const navigate = useNavigate();
  const {t} = useTranslation()
  return (
    <>
      <Stack
        py={3}
        px={{ md: "60px", xs: "10px" }}
        columnGap={14}
        direction={{ md: "row" }}
        rowGap={3}
        alignItems="center"
        backgroundColor="#003893"
        height="auto"
        minHeight="180px"
        sx={{justifyContent : {xs: "flex-start",md : 'center', lg : 'flex-start'}}}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", lg: "row" },
            gap: "50px",
            flexWrap: "wrap",
            justifyContent: { xs: "center", lg: "flex-start" },
            alignItems: { xs: "start", lg: "flex-start" },
          }}
        >
          <Box>
            <LogoIcon />
          </Box>
          <Box>
            <Stack rowGap="20px" columnGap="20px" textAlign="left">
              <Typography variant="h9_1" color="white" letterSpacing="1px">
                Vinga Hall @ Rangoon Road
              </Typography>
              <Stack columnGap="10px" direction="row" alignItems="center">
                <PhoneIcon />
                <Typography variant="h9_3" color="white">
                  +65 6686 6768
                </Typography>
              </Stack>
              <Stack columnGap="10px" direction="row" alignItems="center">
                <LocationIcon fill="#27BAC4" />
                <Typography variant="h9_3" color="white">
                  No.99 Rangoon Road, Singapore 218384
                </Typography>
              </Stack>
              <Stack columnGap="10px" direction="row" alignItems="center">
                <AlternateEmailIcon sx={{color : '#27BAC4'}} />
                <Typography variant="h9_3" color="white">
                  info@dredugroup.com
                </Typography>
              </Stack>
            </Stack>
          </Box>
          <Box></Box>{" "}
          <Stack rowGap="20px" textAlign="left">
            <Typography variant="h9_1" color="white">
              Vinga Hall @ Boon Keng
            </Typography>

            <Stack columnGap="10px" direction="row" alignItems="center">
              <PhoneIcon />
              <Typography variant="h9_3" color="white">
                +65 6686 6768
              </Typography>
            </Stack>
            <Stack columnGap="10px" direction="row" alignItems="center">
              <LocationIcon fill="#27BAC4" />
              <Typography variant="h9_3" color="white">
                10/12 Beng Wan Road, Singapore 339842
              </Typography>
            </Stack>
            <Stack columnGap="10px" direction="row" alignItems="center">
              <AlternateEmailIcon sx={{color : '#27BAC4'}} />
              <Typography variant="h9_3" color="white">
                info@dredugroup.com
              </Typography>
            </Stack>
          </Stack>
          <Stack rowGap="20px" textAlign="left">
            <Typography variant="h9_1" color="white">
              {t("Legal & Policies")}
            </Typography>

            <Stack
              columnGap="10px"
              direction="row"
              alignItems="center"
              onClick={() => {
                navigate("/terms");
              }}
              style={{
                cursor: "pointer",
              }}
            >
              <GavelIcon sx={{ color: "#27BAC4" }} />
              <Typography variant="h9_3" color="white ">
                {t("Terms And Conditions")}
              </Typography>
            </Stack>
            <Stack
              columnGap="10px"
              direction="row"
              alignItems="center"
              onClick={() => {
                navigate("/policyNotice");
              }}
              style={{
                cursor: "pointer",
              }}
            >
              <PolicyIcon sx={{ color: "#27BAC4" }} />
              <Typography variant="h9_3" color="white">
                {t("Policy Notice")}
              </Typography>
            </Stack>
          </Stack>

          <Stack rowGap="20px" textAlign="left">
            <Typography variant="h9_1" color="white">
            {t("Links")}
            </Typography>

            <Stack
              columnGap="10px"
              direction="row"
              alignItems="center"
              onClick={() => {
                navigate("/faq");
              }}
              style={{
                cursor: "pointer",
              }}
            >
              <LiveHelpIcon sx={{ color: "#27BAC4" }} />
              <Typography variant="h9_3" color="white ">
                {t("FAQ")}
              </Typography>
            </Stack>
            <Stack
              columnGap="10px"
              direction="row"
              alignItems="center"
              onClick={() => {
                navigate("/contact-us");
              }}
              style={{
                cursor: "pointer",
              }}
            >
              <InfoIcon sx={{ color: "#27BAC4" }} />
              <Typography variant="h9_3" color="white">
                {t("Help & Support")}
              </Typography>
            </Stack>
          </Stack>
        </Box>
      </Stack>
      <Stack
      sx={{
        px : {xs : "10px", sm : '60px'},
        height : {xs : '100px', sm : '50px'}
      }}
        columnGap={7}
        direction="row"
        alignItems="center"
        backgroundColor="#017BCC"
      >
        <Typography variant="h9_3" color="white">
          © Copyright 2024 Vinga international. All Rights Reserved.
        </Typography>
      </Stack>
    </>
  );
}
